import { ooFetchWithResponse } from './ooFetchWithResponse';

let uploadMappingApi = {
    createChase: async (params) => {
        let url = 'uploadMappings/v1/chase';
        let body = JSON.stringify(params);
        let response = await ooFetchWithResponse(url, { method: "POST", body: body });
        return response;
    },
    createSchwab: async (params) => {
        let url = 'uploadMappings/v1/schwab';
        let body = JSON.stringify(params);
        let response = await ooFetchWithResponse(url, { method: "POST", body: body });
        return response;
    },
    getChase: async () => {
        let url = 'uploadMappings/v1/chase';
        let response = await ooFetchWithResponse(url, {
            method: 'GET',
        });
        return response;
    },
    getSchwab: async () => {
        let url = 'uploadMappings/v1/schwab';
        let response = await ooFetchWithResponse(url, {
            method: 'GET',
        });
        return response;
    },
    removeMapping: async(id) => {
        let url = 'uploadMappings/v1/removeMapping/' + id;
        let response = await ooFetchWithResponse(url, { method: "POST" });
        return response;
    }
}

export { uploadMappingApi };